/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { GlassViewProps } from "./types";

export default CustomPlatform.select<() => React.FC<GlassViewProps>>({
  web: () => require("./GlassView.web").default,
  default: () => require("./GlassView").default,
})();
